<section class="cz-logout">
  <p>{{'$logging_out' | translate}}</p>
</section>
